

<nav style="background-color: rgb(0, 128, 255);">
	<div class="container">
		<div class="row">
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<img (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/accueiladmin" src="../assets/img/homeicon.png" width="30" height="30" />
			</div>
			<div class="text-center text-left col-sm-12 col-md-5 col-lg-5 col-xl-5">
				<h4>
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/ajouter" class="btn btn-outline-light btn-sm">Ajouter</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/modifier" class="btn btn-light btn-sm">Modifier</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/supprimer" class="btn btn-outline-light btn-sm">Supprimer</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/chercher" class="btn btn-outline-light btn-sm">Chercher</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/consulter" class="btn btn-outline-light btn-sm">Consulter</button> &nbsp;
				</h4>
			</div>
			<div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<h4 id="connectnomm"> 
					<button (click)="deconnecter()"  (click)="clicksound()" (mouseenter)="hoversound()" type="button" class="btn btn-outline-dark btn-sm">Déconnecter</button> &nbsp;
				</h4>
			</div>
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<h4>
					<a (click)="clicksound()" (mouseenter)="hoversound()" href="mailto: moahmeddhia.jebali@isticbc.org"  class="btn btn-outline-warning btn-sm">Contacter</a> &nbsp;
      
					<input (click)="clicksound()" (mouseenter)="hoversound()" (click)="aproposderun()" type="button" name="aproposde" id="aproposde" class="btn btn-outline-warning btn-sm" value="À propos de"> &nbsp;
					</h4>
				</div>
			</div>
		</div>
	</nav>
	<br>
		<div class="container">
			<div class="row">
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-6">
					<h1 style="font-size:50px;">Gestion des Employés</h1>
				</div>
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-4">
					<br>
						<h3>Modification d'un employé</h3>
					</div>
					<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-2">
						<img src="../assets/img/modifiericon.png"  width="60" height="50" />
					</div>
				</div>
			</div>
			<br>
				<form>
					<div class="text-center-sm container">
						<div class="row">
							<div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
								<div class="row">
									<div class="col-sm-12 col-md-7 col-lg-7 col-xl-7">
										<h2><label for="eid">EID de l'employé à modifier  &nbsp;</label>
											<input type="text" style="width: 90px; font-size:18px;" name="eid" id="eid" value="8 chiffres" pattern="[0-9]{8}">
											</h2>
										</div>
										<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <input type="button" (mouseenter)="hoversound()" (click)="backend_modifier_chercher()" class="btn btn-warning btn-big " name="verifier" id="verifier" value="Vérifier l'existance de ce Employé">
											
											</div>
										</div>
										<br>
											<div class="row">
												<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                          <h2><label for="cin">CIN &nbsp;</label> 
														<input type="text" style="width: 90px; font-size:18px;" name="cin" id="cin" value="" pattern="[0-9]{8}" disabled>
														</h2>
													</div>
													<div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
														<h2><label for="motdepasse">Mot de Passe  &nbsp;</label> 
															<input type="text" style="width: 140px; font-size:18px;" name="motdepasse" id="motdepasse" value="" pattern=".{3,50}" disabled>
															</h2>
														</div>
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                              <h2><label for="admincb">Administrateur ? &nbsp;  </label> 
                                <input type="checkbox" name="admincb" id="admincb" disabled>
                              </h2>
                              </div>
													</div>
													<br>
                          <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                              <h2><label for="prenom">Prénom  &nbsp;</label> 
                                <h4>
                                  <input type="text" style="font-size:18px;" name="prenom" id="prenom" value="" pattern="[A-z0-9À-ž\s]{3,30}" disabled>&nbsp;&nbsp;&nbsp;
                                  </h4>
                                </h2>
                              </div>
                              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <h2><label for="nom">Nom &nbsp;</label> 
                                  <h4>
                                    <input type="text" style="font-size:18px;" name="nom" id="nom" value="" pattern="[A-z0-9À-ž\s]{3,30}" disabled>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </h4>
                                  </h2>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                  <h2><label for="image">Importer Image &nbsp;</label> 
                                    <h4>
                                      <input type="file" (change) = onSelectFile($event) style="font-size:10px;" name="image" id="image" value="Importer Image" disabled>
                                      </h4>
                                    </h2>
                                  </div>
                                </div>
                                <br>
                                <h2><label for="dn"> Date de Naissance &nbsp;</label>
                                    <input type="date" style="font-size:18px;" name="dn" id="dn" required disabled>
                                    </h2>
                                    <br>
                                      <div class="row">
                                        <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                                          <h2><label for="ville"> Ville &nbsp;</label>
                                            <input type="text" style="font-size:18px;" name="ville" id="ville" value="" pattern="[A-z0-9À-ž\s]{3,30}" disabled> &nbsp;&nbsp;&nbsp;
                                            </h2>
                                          </div>
                                          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <h2><label for="email"> Email &nbsp;</label> 
                                              <input type="email" style="font-size:18px;" name="email" id="email" value="" required disabled>
                                              </h2>
                                            </div>
                                          </div>
                                          <br>
                                            <div class="row">
                                              <div class="col-sm-12 col-md-6 col-lg-8 col-xl-6">
                                                <h2><label for="tel">Numéro Téléphone &nbsp;</label> 
                                                  <input type="text" size=10 style="font-size:18px;" name="tel" id="tel" value="" pattern="[0-9]{8}" disabled>&nbsp;&nbsp;&nbsp;
                                                  </h2>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                  <h2><label for="salaire">Salaire &nbsp;</label> 
                                                    <input type="text" style="width: 80px; font-size:18px;" name="salaire" id="salaire" value="" pattern="[0-9]{1,5}" disabled> DT
                                                    </h2>
                                                  </div>
                                                </div>
                                                </div>
                                                <div class=" col-sm-12 col-md-3 col-lg-3 col-xl-3 ">
                                                  <input input (click)="clicksound()" (mouseenter)="hoversound()" (click)="ajoutertache()" type="button" class="btn btn-dark"name="ajoutertac" id="ajoutertac" value="Ajouter Tâche" pattern="[A-z0-9À-ž\s]{3,30}" disabled>
                                                  
                                                    <br>
                                                      <br>
                                                      <div id="ac">
                                                        
                                                    
                                                    </div>
                                                            </div>
                                                          </div>
                                                          
                                                          <br>
                                                          <hr>
                                                            <input type="button" (mouseenter)="hoversound()" (click)="backend_modifier()" style="float: right;" class="btn btn-primary btn-lg" name="modifiersub" id="modifiersub" value="Modifier Employé" disabled>&nbsp;&nbsp;&nbsp;

                                                              <br>&nbsp;
                                                                <br>&nbsp;

                                                                </div>
                                                              </form>
